// extracted by css-extract-rspack-plugin
export default {"cls1":"BackButton-cls1_fEB","cls2":"BackButton-cls2_4Va BackButton-cls1_fEB"};